import type { PhotoRef } from './media';

export interface ITypedEntity {
  typeName: TypeNames;
}

export interface IStorable extends ITypedEntity {
  createdAt?: number;
  updatedAt?: number;
}

export interface IIdentifiedStorable extends IStorable {
  id: string;
}

export interface IPropertyScopedStorable extends IIdentifiedStorable {
  propertyID: string;
}

export interface IDisplayEntity {
  title?: string;
  description?: string | null;
}

export interface IMediaEntity {
  thumbnail?: string | null;
  thumbnailUrl?: string | null;
  photos?: PhotoRef[] | null;
}

export interface IContentEntity extends IIdentifiedStorable, IDisplayEntity, IMediaEntity {}

export interface IPropertyContentEntity extends IContentEntity {
  propertyID: string;
}

export const TypeNames = {
  User: 'User',
  BusinessUser: 'BusinessUser',
  Property: 'Property',
  PropertyMember: 'PropertyMember',
  Location: 'Location',
  Project: 'Project',
  ProjectEvent: 'ProjectEvent',
  Item: 'Item',
  Category: 'Category',
  Bill: 'Bill',
  Party: 'Party',
  DeviceToken: 'DeviceToken',
  System: 'System',
  Reminder: 'Reminder',
  Role: 'Role',
  Organization: 'Organization',
  OrganizationMember: 'OrganizationMember',
  Invitation: 'Invitation',
  SupportTicket: 'SupportTicket',
  SupportMessage: 'SupportMessage',
  Schema: 'Schema',
  Subscription: 'Subscription',
  PropertyTemplate: 'PropertyTemplate',
  PropertyEvent: 'PropertyEvent',
  PropertyExpenseEntry: 'PropertyExpenseEntry',
  PropertyExpenseRollup: 'PropertyExpenseRollup',
  PropertyHandoverClaim: 'PropertyHandoverClaim',
  Notification: 'Notification',
  Document: 'Document',
  DocumentVersion: 'DocumentVersion',
  DocumentLink: 'DocumentLink',
  DocumentAuditEvent: 'DocumentAuditEvent',
  ChecklistTemplate: 'ChecklistTemplate',
  Checklist: 'Checklist',
  ChecklistItem: 'ChecklistItem',
  ChecklistItemEvidence: 'ChecklistItemEvidence',
  ChecklistSignoff: 'ChecklistSignoff',
  ChecklistAuditEvent: 'ChecklistAuditEvent',
  SystemSettings: 'SystemSettings',
} as const;

export type TypeNames = (typeof TypeNames)[keyof typeof TypeNames];

/** @deprecated Prefer IIdentifiedStorable for identified API records. */
export type IAwsRecord = IIdentifiedStorable;

export type DynamoDBValue = string | number | boolean | null;
